export function isTouch() {
    return window.matchMedia != null && window.matchMedia('(pointer: coarse)').matches;
}
